import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Onethreetempotravelleronrent() {



  const cardData = {
"keyword": "13 Tempo Traveller On Rent in Pune",

"headingDescription":
  "Shivai Travels offers reliable 13 Seater Tempo Traveller on rent in Pune for comfortable group travel including family tours, corporate outings, wedding transportation, airport transfers, pilgrimage trips, local sightseeing, and outstation journeys across Maharashtra and nearby destinations. Our 13 Seater Tempo Traveller is designed for smooth and safe travel with spacious pushback seating, powerful air conditioning, clean interiors, charging points, music system, and ample luggage space, making it ideal for medium-sized groups. Perfect for 10–13 passengers, this vehicle ensures everyone travels together comfortably without the hassle of multiple cars. With experienced drivers, well-maintained vehicles, flexible rental packages, doorstep pickup and drop, and 24/7 customer support, Shivai Travels ensures a safe, affordable, and hassle-free travel experience in and around Pune.",

"topPlaces": [
  {
    "title": "Lonavala & Khandala",
    "description":
      "Lonavala and Khandala are the most popular hill stations near Pune known for waterfalls, forts, green valleys, and monsoon scenery, making them ideal for 13 Seater Tempo Traveller group trips."
  },
  {
    "title": "Lavasa",
    "description":
      "Lavasa is a planned hill city near Pune known for lakeside promenades, colorful architecture, and peaceful surroundings, perfect for one-day group outings."
  },
  {
    "title": "Sinhagad Fort",
    "description":
      "Sinhagad Fort is a historic fort near Pune famous for trekking, panoramic views of the Sahyadri range, and local Maharashtrian food stalls, ideal for adventure group trips."
  },
  {
    "title": "Khadakwasla Dam",
    "description":
      "Khadakwasla Dam is a popular picnic spot near Pune known for scenic water views, sunset points, and relaxing evening outings for families and groups."
  },
  {
    "title": "Pawna Lake",
    "description":
      "Pawna Lake is a famous camping destination near Lonavala known for lakeside views, camping activities, bonfires, and peaceful sunset experiences for group travel."
  },
  {
    "title": "Tamhini Ghat",
    "description":
      "Tamhini Ghat is a scenic monsoon route near Pune known for waterfalls, misty hills, and lush greenery, making it ideal for road trips and nature outings."
  },
  {
    "title": "Mulshi Dam",
    "description":
      "Mulshi Dam is a peaceful natural spot near Pune surrounded by Sahyadri hills and greenery, perfect for picnic and group travel experiences."
  },
  {
    "title": "Aga Khan Palace",
    "description":
      "Aga Khan Palace in Pune is a historic landmark known for its architecture and importance in India’s freedom movement, commonly included in city sightseeing tours."
  },
  {
    "title": "Shaniwar Wada",
    "description":
      "Shaniwar Wada is a famous historical fort in Pune known for Maratha heritage, architecture, and light-and-sound shows, ideal for city tours."
  },
  {
    "title": "Dagadusheth Halwai Ganpati Temple",
    "description":
      "Dagadusheth Ganpati Temple is one of the most visited religious landmarks in Pune, attracting devotees from across Maharashtra for darshan and blessings."
  }
],



services: [
  {
    name: "13 Seater Tempo Traveller Pune",
    description: "13 seater Tempo Traveller Pune service provides premium and spacious transportation for airport transfers, family trips, corporate travel, sightseeing tours, weddings, and outstation journeys. Comfortable Tempo Traveller vehicles with experienced drivers ensure smooth and safe travel for local and long-distance routes. Pickup services are available from homes, hotels, railway stations, offices, and airport terminals across Pune. Vehicles offer pushback seating, air conditioning, music systems, and luggage space suitable for executive and family travel requirements. Flexible booking options allow convenient 13 seater Tempo Traveller reservations in Pune."
  },
  {
    name: "Pune 13 Tempo Traveller Rental",
    description: "Pune 13 Tempo Traveller rental service offers dependable transportation solutions for travelers seeking comfortable group travel within Pune and nearby destinations. Vehicles provide spacious seating and smooth highway travel suitable for tourism, corporate outings, airport travel, and family vacations. Professional chauffeurs ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient 13 Tempo Traveller rental reservations."
  },
  {
    name: "13 Tempo Traveller Hire Pune",
    description: "13 Tempo Traveller hire Pune service provides affordable and comfortable travel options for local and outstation journeys. Travelers can enjoy smooth trips with experienced drivers familiar with city roads, highways, and tourist destinations. Vehicles ensure spacious seating and safe transportation suitable for business trips, family vacations, and airport travel. Pickup services are available from homes, offices, hotels, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 13 Tempo Traveller hire reservations."
  },
  {
    name: "Cheap 13 Seater Traveller Pune",
    description: "Cheap 13 seater traveller Pune service provides economical transportation for passengers seeking comfortable and budget-friendly group travel. Vehicles offer spacious seating, luggage capacity, and smooth ride quality suitable for tourism, office travel, and personal journeys. Professional drivers ensure safe driving and timely pickup services throughout the journey. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient affordable 13 seater traveller reservations."
  },
  {
    name: "Luxury 13 Tempo Traveller Pune",
    description: "Luxury 13 Tempo Traveller Pune service offers high-end transportation for groups traveling within Pune and nearby destinations. Vehicles provide smooth highway travel with spacious seating, premium interiors, and comfortable travel suitable for one-day tours, airport transfers, and family outings. Professional drivers ensure punctual pickup and safe driving services throughout the trip. Pickup services are available from homes, offices, hotels, railway stations, and airports across Pune. Flexible booking options allow convenient luxury 13 Tempo Traveller reservations."
  },
  {
    name: "Outstation 13 Tempo Traveller Pune",
    description: "Outstation 13 Tempo Traveller Pune service provides comfortable transportation for families, corporate teams, and tourists traveling from Pune to outstation destinations. Vehicles ensure smooth highway travel with spacious seating and luggage capacity suitable for tourism, pilgrimage tours, and weekend trips. Professional drivers ensure punctual pickup and safe driving services throughout the journey. Pickup services are available across Pune including homes, hotels, offices, railway stations, and airports. Flexible booking options allow convenient outstation 13 Tempo Traveller reservations."
  },
  {
    name: "Airport 13 Tempo Traveller Pune",
    description: "Airport 13 Tempo Traveller Pune service offers spacious transportation for airport transfers, family tours, corporate outings, and sightseeing trips. Vehicles provide comfortable seating, air conditioning, and smooth highway performance suitable for long-distance journeys and executive travel. Professional chauffeurs ensure safe driving and timely pickup services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient airport 13 Tempo Traveller reservations."
  },
  {
    name: "13 Traveller Booking Pune",
    description: "13 traveller booking Pune service provides reliable transportation for airport pickup and drop services from Pune Airport and nearby locations. Vehicles offer spacious seating, luggage space, and comfortable travel suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure smooth travel and dependable pickup services throughout the trip. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient 13 traveller booking reservations."
  },
  {
    name: "13 Tempo Traveller One Way Pune",
    description: "13 Tempo Traveller one way Pune service provides dependable transportation for long-distance group travel from Pune to tourist destinations, pilgrimage places, beaches, and hill stations. Comfortable vehicles ensure smooth highway travel suitable for tourism, corporate tours, and family vacations. Professional chauffeurs ensure safe driving and reliable transportation services throughout the journey. Pickup services are available across Pune including homes, hotels, railway stations, and airports. Flexible booking options allow convenient one-way 13 Tempo Traveller reservations."
  },
  {
    name: "13 Tempo Traveller Round Trip Pune",
    description: "13 Tempo Traveller round trip Pune service offers spacious and comfortable transportation for one-side and return travel from Pune to nearby cities and tourist destinations. Vehicles provide comfortable seating and luggage space suitable for family groups, business teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient round trip 13 Tempo Traveller reservations."
  },
  {
    name: "Best 13 Tempo Traveller Pune",
    description: "Best 13 Tempo Traveller Pune service offers premium transportation for sightseeing tours, family vacations, pilgrimage journeys, and business travel with return options. Vehicles ensure comfortable seating and smooth travel suitable for large family groups and corporate outings. Professional chauffeurs ensure safe driving and timely pickup services for all travel requirements. Pickup services are available from homes, hotels, banquet halls, railway stations, and airports across Pune. Flexible booking options allow convenient best 13 Tempo Traveller reservations."
  },
  {
    name: "13 Tempo Traveller with Driver Pune",
    description: "13 Tempo Traveller with driver Pune service offers reliable group transportation for airport pickup and drop services, sightseeing tours, and outstation travel. Vehicles provide spacious seating and luggage space suitable for family groups, corporate teams, and tourist travelers. Professional drivers ensure punctual transfers and safe transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient 13 Tempo Traveller with driver reservations."
  },
  {
    name: "Family 13 Traveller Pune",
    description: "Family 13 traveller Pune service provides complete luxury transportation solutions for local and outstation group travel requirements. Vehicles ensure smooth highway travel suitable for tourism, corporate events, pilgrimage tours, and family vacations. Professional chauffeurs ensure safe driving and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient family 13 traveller reservations."
  },
  {
    name: "Group 13 Seater Traveller Pune",
    description: "Group 13 seater traveller Pune service offers comfortable and dependable transportation with modern vehicles and experienced chauffeurs. Vehicles are suitable for family trips, sightseeing tours, airport transfers, corporate outings, and long-distance travel. Professional drivers ensure safe driving and reliable transportation services throughout the journey. Pickup services are available from homes, hotels, offices, railway stations, and airport terminals across Pune. Flexible booking options allow convenient group 13 seater traveller reservations."
  },
  {
    name: "AC 13 Tempo Traveller Pune",
    description: "AC 13 Tempo Traveller Pune service provides luxury transportation for groups looking for premium travel experiences with spacious seating and comfortable interiors. Vehicles are suitable for corporate events, destination outings, sightseeing trips, airport travel, and family tours. Professional chauffeurs ensure smooth journeys and dependable transportation services throughout the route. Pickup services are available from homes, hotels, offices, railway stations, and airports across Pune. Flexible booking options allow convenient AC 13 Tempo Traveller reservations."
  }
],

tableData: [
  ["13 Seater Tempo Traveller Pune", "Pune 13 Tempo Traveller Rental"],
  ["13 Tempo Traveller Hire Pune", "Cheap 13 Seater Traveller Pune"],
  ["Luxury 13 Tempo Traveller Pune", "Outstation 13 Tempo Traveller Pune"],
  ["Airport 13 Tempo Traveller Pune", "13 Traveller Booking Pune"],
  ["13 Tempo Traveller One Way Pune", "13 Tempo Traveller Round Trip Pune"],
  ["Best 13 Tempo Traveller Pune", "13 Tempo Traveller with Driver Pune"],
  ["Family 13 Traveller Pune", "Group 13 Seater Traveller Pune"],
  ["AC 13 Tempo Traveller Pune", "13 Seater Tempo Traveller Pune"]
],


 whychoose: [
      {
        WhyChooseheading: "Reliable 13 Seater Tempo Traveller on Rent in Pune",
        WhyChoosedescription: "Shivai Travels provides reliable 13 seater Tempo Traveller rental service in Pune with professional drivers, comfortable seating, and punctual pickup for smooth and safe group travel experiences."
      },
      {
        WhyChooseheading: "Affordable 13 Seater Tempo Traveller Pricing",
        WhyChoosedescription: "Shivai Travels offers affordable 13 seater Tempo Traveller on rent in Pune with transparent pricing and no hidden charges. Customers receive complete fare details before confirming their booking."
      },
      {
        WhyChooseheading: "24/7 Tempo Traveller Availability",
        WhyChoosedescription: "Our 13 seater Tempo Traveller rental service in Pune operates 24 hours a day for family tours, corporate outings, weddings, airport transfers, pilgrimage trips, and emergency transportation requirements."
      },
      {
        WhyChooseheading: "Comfortable & Clean AC Tempo Travellers",
        WhyChoosedescription: "All 13 seater Tempo Travellers provided by Shivai Travels are fully air-conditioned, sanitized, spacious, and regularly maintained to provide comfortable local and long-distance group travel experiences."
      },
      {
        WhyChooseheading: "One Way & Round Trip Booking Options",
        WhyChoosedescription: "Shivai Travels offers flexible travel options including one-way 13 seater Tempo Traveller booking, round-trip travel, airport transfers, local sightseeing, and customized outstation travel packages."
      },
      {
        WhyChooseheading: "Ideal for Family & Group Tours",
        WhyChoosedescription: "Our 13 seater Tempo Travellers are ideal for family vacations, wedding groups, corporate teams, tourists, school trips, and pilgrimage travel with spacious seating and luggage capacity."
      },
      {
        WhyChooseheading: "Doorstep Pickup Across Pune",
        WhyChoosedescription: "Shivai Travels provides convenient pickup from homes, offices, hotels, Pune Airport, railway stations, and all major Pune areas including Baner, Wakad, Hinjewadi, Kharadi, and Hadapsar."
      },
      {
        WhyChooseheading: "Experienced Drivers for Group Travel",
        WhyChoosedescription: "Our experienced drivers are familiar with Pune city routes, highways, Konkan roads, hill stations, and interstate destinations, ensuring safe driving and smooth travel for every group journey."
      }
    ]
  };

  const faqData = [
    { question: "What is 13 seater Tempo Traveller rental service in Pune?", answer: "13 seater Tempo Traveller rental service in Pune provides comfortable group transportation for family tours, corporate outings, weddings, sightseeing trips, and outstation journeys." },
    { question: "Is 13 seater Tempo Traveller on rent in Pune available 24 hours?", answer: "Yes, Shivai Travels provides 24/7 13 seater Tempo Traveller rental service in Pune." },
    { question: "Can I book 13 seater Tempo Traveller for outstation travel?", answer: "Yes, customers can book 13 seater Tempo Travellers for local sightseeing, airport transfers, family tours, corporate trips, and outstation travel." },
    { question: "Do you provide one-way and round-trip 13 seater Tempo Traveller service?", answer: "Yes, Shivai Travels provides both one-way and round-trip 13 seater Tempo Traveller booking services." },
    { question: "Are all 13 seater Tempo Travellers air-conditioned?", answer: "Yes, all 13 seater Tempo Travellers are fully air-conditioned and maintained for comfortable group travel." },
    { question: "Can I book 13 seater Tempo Traveller on rent in Pune online?", answer: "Yes, customers can easily book 13 seater Tempo Traveller rental service online or through phone booking." },
    { question: "Do you provide 13 seater Tempo Travellers for weddings and corporate events?", answer: "Yes, Shivai Travels provides 13 seater Tempo Travellers for weddings, corporate outings, airport transfers, and family group travel." },
    { question: "Are 13 seater Tempo Traveller rental fares transparent?", answer: "Yes, Shivai Travels provides affordable and transparent pricing without hidden charges." },
    { question: "What is the starting per km rate for 13 seater Tempo Traveller in Pune?", answer: "13 seater Tempo Traveller rental rates in Pune generally start from ₹22 to ₹30 per kilometer depending on AC configuration and travel route." },
    { question: "Is advance booking available for 13 seater Tempo Traveller rental in Pune?", answer: "Yes, advance booking is available and recommended during weekends, holidays, wedding seasons, and peak travel periods." }
  ];

  const testimonials = [
    {
      id: 1,
      name: "Mr. Rohit Patil",
      feedback:
        "Booked 13 seater Tempo Traveller on rent in Pune with Shivai Travels. Comfortable vehicle, smooth journey, and excellent driver support for our family trip.",
      rating: 5
    },
    {
      id: 2,
      name: "Mrs. Snehal Kulkarni",
      feedback:
        "Excellent 13 seater Tempo Traveller rental service in Pune. Affordable pricing, clean vehicle, and wonderful group travel experience.",
      rating: 5
    }
  ];


  

  const Images = [
    { place: "/images/keyword/1.jpg", text: "Pune Outstation Cab Service", link: "Pune-Outstation-Cab-Service" },
    { place: "/images/keyword/2.jpg", text: "Pune Taxi Service", link: "Pune-Taxi-Service" },
    { place: "/images/keyword/3.jpg", text: "Pune Cab Booking", link: "Pune-Cab-Booking" },
    { place: "/images/keyword/4.jpg", text: "Best Cab Service in Pune", link: "Best-Cab-Service-in-Pune" },
    { place: "/images/keyword/5.jpg", text: "Outstation Taxi Service Pune", link: "Outstation-Taxi-Service-Pune" },
    { place: "/images/keyword/6.jpg", text: "Cheap Cabs in Pune", link: "Cheap-Cabs-in-Pune" },
    { place: "/images/keyword/7.jpg", text: "Pune Cab Fare", link: "Pune-Cab-Fare" },
    { place: "/images/keyword/8.jpg", text: "Corporate Cab Service Pune", link: "Corporate-Cab-Service-Pune" },
    { place: "/images/keyword/9.jpg", text: "Pune Airport Cab", link: "Pune-Airport-Cab" },
    { place: "/images/keyword/10.jpg", text: "Pune Railway Station Cab Service", link: "Pune-Railway-Station-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Pune One Way Cab Service", link: "Pune-One-Way-Cab-Service" },
    { place: "/images/keyword/12.jpg", text: "Pune Local and Outstation Cab", link: "Pune-Local-and-Outstation-Cab" },
    { place: "/images/keyword/13.jpg", text: "Pune to Mumbai Cab", link: "Pune-to-Mumbai-Cab" },
    { place: "/images/keyword/14.jpg", text: "Pune to Mumbai Airport Cab", link: "Pune-to-Mumbai-Airport-Cab" },
    { place: "/images/keyword/15.jpg", text: "Pune to Nashik Cab Service", link: "Pune-to-Nashik-Cab-Service" },
    { place: "/images/keyword/16.jpg", text: "Pune to Nagpur Cab", link: "Pune-to-Nagpur-Cab" },
    { place: "/images/keyword/17.jpg", text: "Pune to Kolhapur Cab", link: "Pune-to-Kolhapur-Cab" },
    { place: "/images/keyword/18.jpg", text: "Pune to Solapur Cab Service", link: "Pune-to-Solapur-Cab-Service" },
    { place: "/images/keyword/19.jpg", text: "Pune to Ahmednagar Taxi", link: "Pune-to-Ahmednagar-Taxi" },
    { place: "/images/keyword/20.jpg", text: "Pune to Sangli Cab", link: "Pune-to-Sangli-Cab" },
    { place: "/images/keyword/21.jpg", text: "Pune to Satara Cab Service", link: "Pune-to-Satara-Cab-Service" },
    { place: "/images/keyword/22.jpg", text: "Pune to Jalgaon Cab Service", link: "Pune-to-Jalgaon-Cab-Service" },
    { place: "/images/keyword/23.jpg", text: "Pune to Dhule Cab Service", link: "Pune-to-Dhule-Cab-Service" },
    { place: "/images/keyword/24.jpg", text: "Pune to Thane Cab", link: "Pune-to-Thane-Cab" },
    { place: "/images/keyword/25.jpg", text: "Pune to Panvel Cab", link: "Pune-to-Panvel-Cab" },

  ];











const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "13 Seater Tempo Traveller on Rent in Pune",
  "image": "https://shivaitravels.com/assets/images/13-seater-tempo-traveller-pune.jpg",
  "description": "Book 13 seater Tempo Traveller on rent in Pune with Shivai Travels for comfortable and safe group travel. Ideal for family trips, corporate travel, airport transfers, weddings, and outstation journeys. Available with AC comfort, professional driver, and flexible one-way and round-trip options.",
  "brand": {
    "@type": "Brand",
    "name": "Shivai Travels"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "5471"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹22/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://shivaitravels.com/13-tempo-traveller-pune"
  }
};




  return (
    <div>
<Helmet>
  <title>13 Seater Tempo Traveller on Rent in Pune | Group Travel Cab | Shivai Travels | +91 9689815477</title>

  <meta
    name="description"
    content="Book 13 seater Tempo Traveller in Pune with Shivai Travels. Spacious AC group travel vehicle for family trips, corporate travel, airport transfers, weddings, and outstation journeys. Available 24x7 with driver."
  />

  <meta
    name="keywords"
    content="13 seater tempo traveller pune, pune 13 tempo traveller rental, 13 tempo traveller hire pune, cheap 13 seater traveller pune, luxury 13 tempo traveller pune, outstation 13 tempo traveller pune, airport 13 tempo traveller pune, 13 traveller booking pune, 13 tempo traveller one way pune, 13 tempo traveller round trip pune, best 13 tempo traveller pune, 13 tempo traveller with driver pune, family 13 traveller pune, group 13 seater traveller pune, ac 13 tempo traveller pune"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>





      <div className="breadcrumb-bar">
        <div className="container">
          <div className="row align-items-center text-center">
            <div className="col-md-12 col-12">
              <h2 className="breadcrumb-title text-white"> {cardData.keyword}</h2>

            </div>
          </div>
        </div>
      </div>













      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/10.jpeg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#3F1B0D', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Shivai Travels: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Shivai Travels</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Shivai Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919689815477" className="pc-call">+91 9689815477</a>
                    </div>

                    <div className="pc-cta">
                    <a
  href="https://wa.me/919689815477?text=Welcome%20to%20Shivai%20Travels!%20%F0%9F%9A%8C%0AWe%20are%20happy%20to%20assist%20you%20with%20comfortable%20and%20safe%20travel%20services.%20Please%20let%20us%20know%20how%20we%20can%20help%20you."
  target="_blank"
  rel="noopener noreferrer"
  className="pc-whats"
>
  <i className="bi bi-whatsapp"></i> WhatsApp
</a>
                      <a href="tel:+919689815477" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@shivaitravels.com" className="pc-email">
                      booking@shivaitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Shivai Travels</strong><br />
                      Shop no 1, Kamdhenu nagar, Guru mauli society, Vadgaon road, Near super bazar, Alandi, Pune 412105
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Onethreetempotravelleronrent;